import React, {useState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import LoginBlock from './LoginBlock';
import SignupForm from './SignupForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUserCircle} from '@fortawesome/free-solid-svg-icons/faUserCircle';
import styles from '../styles/login/LoginForm.module.css';

const ConnectBlock = (props) => {

    const {onboard, email} = props;
    const [key, setKey] = useState(onboard);

    const changeActiveTab = (e) => { setKey(e);}

    let tabs = 
        <Row className="justify-content-center py-0 g-0">
            <Col xs="12" sm="8" lg="10" >
                <Tabs activeKey={key}  onSelect={changeActiveTab}>
                    <Tab eventKey="login" title="Login" tabClassName="w-50 text-center"></Tab>
                    <Tab eventKey="signup" title="Creeaza cont" tabClassName="w-50 text-center"></Tab>
                </Tabs> 
            </Col>
        </Row>;

    let userForm = key == "login" ? 
        <Row className={`justify-content-center m-0 `}>
            <LoginBlock 
                xs="12" sm="8" lg="10" 
                redirectUrl={false} 
                openAccountLink={false} 
                defaultEmail={email} 
            />
        </Row>
        : 
        <Row className="justify-content-center py-0 m-0">
            <Col xs="12" sm="8" lg="10" className={`bg-white p-5 ${styles.frameBorder}`}>
            <h1 className="heading2 black-text text-center">Creeaza un cont nou</h1>
            <p className="text-center red">
                <FontAwesomeIcon icon={faUserCircle} height={60} width={60} size="5x"/>
            </p>
                <SignupForm 
                    redirectUrl={false} 
                    loginLink={false} 
                    defaultEmail={email} 
                />
            </Col>
        </Row>
        ;

    return (
        <section>
            {tabs}
            {userForm}
        </section>
    );

}

export default ConnectBlock;